import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { RoleGuard } from '../guards'
import { ControlOutlined, TagsOutlined } from '@ant-design/icons-vue'
import type { RouteRecordRaw } from 'vue-router'

export const super_admin_routes: RouteRecordRaw[] = [
  {
    path: '/plans',
    name: 'plans',
    component: () => getComponent(`pages/plans.vue`),
    meta: {
      title: () => 'Plans',
      layout: Layout,
      is_public: false,
      guard: RoleGuard(['super_admin']),
      menu: {
        separate: true,
        key: 'Plans',
        label: 'Plans',
        icon: () => h(TagsOutlined),
        path: `${prefix}/plans`,
      },
    },
  }
]
